export enum PresentationType {
  PRESENTATION = 1,
  ARCHIVED = 2
}
